<template>
  <layout>
    <template v-slot:header>
      <AppHead title="Create Category" />
      <h2>Create Category</h2>
      <BreadCrumbs activeItem="Create Category" :crumbs="{ home: 'Dashboard', categories: 'Categories'}"/>
      <flash-messages />
    </template>
    
    <template v-slot:default>
      <div class="col-12 col-xl-8 px-0">
        <card headerStyle="dark" title="New Category">
          <form @submit.prevent="store">
            <div class="row">
              <div class="form-group col-sm-6">
                <jet-label for="name" value="Name" />
                <jet-input id="name"  type="text" class="form-control" v-model="form.name" />
                <jet-input-error :message="form.errors.name" class="mt-2" />
              </div>

              <div class="form-group col-sm-6">
                <jet-label for="parent_id" value="Parent" />
                <select v-model="form.parent_id" class="form-control">
                  <option v-for="category in this.categories" :key="category.id" :value="category.id">
                    {{ category.name }}
                  </option>
                </select>
                <jet-input-error :message="form.errors.parent_id" class="mt-2" />
              </div>
            </div>

            <div class="col-12 d-flex align-items-end my-3">
              <div class="form-check">
                <input type="checkbox" id="active" class="form-check-input" v-model="form.active" />
                <jet-label for="active" value="Active" />
                <jet-input-error :message="form.errors.active" class="mt-2" />
              </div>
            </div>

            <div class="bottom-button">
              <jet-button class="px-5" btnStyle="success" icon="fas fa-plus" :disable="form.processing" type="submit">Create Category</jet-button>
            </div>
          </form>
        </card>
      </div>
    </template>
  </layout>
</template>

<script>
  import Layout from '@/Shared/Admin/Layout'
  import FileInput from '@/Shared/FileInput'
  import TextInput from '@/Shared/TextInput'
  import SelectInput from '@/Shared/SelectInput'

  import JetButton from '@/Jetstream/Button'
  import JetFormSection from '@/Jetstream/FormSection'
  import JetInput from '@/Jetstream/Input'
  import JetCheckbox from '@/Jetstream/Checkbox'
  import JetInputError from '@/Jetstream/InputError'
  import JetLabel from '@/Jetstream/Label'
  import JetActionMessage from '@/Jetstream/ActionMessage'
  import FlashMessages from '@/Shared/FlashMessages'
  import BreadCrumbs from '@/Shared/BreadCrumbs'

  export default {
    components: {
      FileInput,
      SelectInput,
      TextInput,
      JetActionMessage,
      JetButton,
      JetFormSection,
      JetInput,
      JetCheckbox,
      JetInputError,
      JetLabel,
      FlashMessages,
      Layout,
      BreadCrumbs
    },
    remember: 'form',
    props: {
      categories: Object
    },
    data() {
      return {
        form: this.$inertia.form({
          name: null,
          parent_id: null,
          active: true,
        }),
      }
    },
    methods: {
      store() {
        this.form.post(this.route('categories.store'))
      },
    },
  }
</script>
